import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideSharingService extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  active: boolean;
}
